export const _en = {
    name: {
        label: "Name"
    },
    description: {
        label: "Description"
    },
    code: {
        label: "Code"
    },
    traineeNumber: {
        label: "Max trainee number"
    },
    refDivisionId: {
        label: "Division"
    },
    preferenceOrder: {
        label: "Selection order"
    }
};

export const _fr = {
    name: {
        label: "Nom"
    },
    description: {
        label: "Description"
    },
    code: {
        label: "Code"
    },
    traineeNumber: {
        label: "Nombre maximum de stagiaires"
    },
    refDivisionId: {
        label: "Service"
    },
    preferenceOrder: {
        label: "Rang d'affectation préférentiel"
    }
};